module.exports = __webpack_public_path__ + "static/media/masthead-countryman.fe48c382.svg";